import { ActionCreator } from 'store/redux/ActionCreators';
import { HarvestYield } from '../types/HarvestYield';

export enum HarvestAction {
  ReceiveHarvestMetadata = 'RECEIVE_HARVEST_METADATA',
}
export interface ReceiveHarvestMetadataAction {
  type: HarvestAction.ReceiveHarvestMetadata,
  metadata: HarvestYield[]
}

export function receiveHarvestMetadata(metadata: HarvestYield[]): ReceiveHarvestMetadataAction {
  return {
    type: HarvestAction.ReceiveHarvestMetadata,
    metadata,
  };
}

export type HarvestActions = ReceiveHarvestMetadataAction;

export interface HarvestActionsCreators {
  receiveHarvestMetadata: ActionCreator<
    { metadata: HarvestYield[] },
    ReceiveHarvestMetadataAction
  >;
}